import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { LuReceiptText } from 'react-icons/lu';

import { checkIn, getCheckInBalance } from '../api';
import Spinner from '../components/common/Spinner';
import { STORAGE_KEY } from '../constants';
import Notification from '../components/Notification';
import Button from '../components/common/Button';

const PaymentPage = () => {
  const [balance, setBalance] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  const handleCheckIn = async () => {
    const roomNo = localStorage.getItem(STORAGE_KEY.ROOM_NO);
    const { status } = await checkIn({ balance_amount: balance, room_no: roomNo });

    if (status === 200) {
      const params = localStorage.getItem(STORAGE_KEY.PARAMS);
      if (params) {
        const { hotelCode, reservationNo } = JSON.parse(params);
        navigate(`/?h=${hotelCode}&r=${reservationNo}`, { replace: true });
      }
    }
  };

  const handlePayment = () => {
    return;
  };

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { balance_amount },
        } = await getCheckInBalance();
        setBalance(balance_amount);

        if (balance_amount === 0) {
          await handleCheckIn();
        }
      } catch (error) {
        if (error instanceof AxiosError) {
          setErrorMessage(error.response?.data.message);
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Spinner />;
  if (isError) return <Notification message={errorMessage} />;

  return (
    <div className="flex flex-col gap-y-6">
      <h1 className="text-xl font-bold">결제</h1>
      <span>
        금액을 확인하신 후, 결제를 진행해 주세요. <br />
        결제가 완료되면 <strong>체크인 처리</strong>가 됩니다.
      </span>
      <div className="flex items-center gap-x-2">
        <LuReceiptText size={24} />
        <span className="text-lg font-semibold">
          금액: <span className="text-purple-700">{balance}원</span>
        </span>
      </div>
      <Button onClick={handlePayment}>결제</Button>
    </div>
  );
};

export default PaymentPage;
